import "components/form/Select/Select.scss";
import { ReactComponent as IconChevronDown } from "assets/images/icons/chevron-down.svg";
import PropTypes from "prop-types";

function Select({ value, items, variant, addEmptyOption = false, onChange }) {
  return (
    <div className={ `select select--${ variant }` }>
      <select value={ value }
              onChange={ event => onChange(event.target.value) }
              className={ `select__element select__element--${ variant }` }>
        {
          addEmptyOption &&
            <option key={ -1 } value={ `` }>- Maak een keuze -</option>
        }
        {
          items.map(item => <option key={ item.id } value={ item.id }>{ item.value }</option>)
        }
      </select>

      <div className={ `select__icon select__icon--${ variant }` }>
        <IconChevronDown/>
      </div>
    </div>
  );
}

Select.propTypes = {
  value: PropTypes.any,
  items: PropTypes.array,
  variant: PropTypes.string,
  addEmptyOption: PropTypes.bool,
  onChange: PropTypes.func
}

export default Select;
